/*
  Mi pedido — el carrito propio de La Tinta.

  El carrito de Shopify no sirve para esta tienda: el precio sale de acomodar
  TODAS las piezas de un papel en el rollo, no de sumar lineas. Por eso aqui
  se guardan solo las PIEZAS, agrupadas por papel, y el precio se recalcula
  siempre con el motor (assets/cotizador-engine.js). Nunca se guarda un precio.

  Formato de cada grupo: { paper: 'fs-smooth', cq: '2_30_40-1_60_90', origen }
  donde cq es el mismo formato del enlace del cotizador (cq_i), asi que el
  paso 2 de /products/cotizador lo entiende sin traduccion.

  Se paga en /products/cotizador?mp=1: alli se suben los archivos (Upload-Lift
  solo se dibuja en paginas de producto) y se crea UN pedido borrador.
*/
(function () {
  'use strict';
  if (window.MiPedido) return;

  var CFG = window.MP_CFG || {};
  var KEY = 'lt_mipedido_v1';
  var COLORES = ['#D6232A', '#2F6FB0', '#3E8E5A', '#C9821F', '#7A4BB0', '#1F8C8C', '#B0457A', '#5B5B57'];

  /* ───────────────────────── datos ───────────────────────── */

  function leer() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || 'null');
      return d && Array.isArray(d.grupos) ? d : { grupos: [] };
    } catch (e) { return { grupos: [] }; }
  }
  function guardar(d) {
    d.t = Date.now();
    try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {}
    cambio();
  }

  function parse(cq) {
    return String(cq || '').split('-').map(function (t) {
      var p = t.split('_');
      var q = parseInt(p[0], 10), w = parseFloat(p[1]), h = parseFloat(p[2]);
      return (q > 0 && w > 0 && h > 0) ? { qty: q, w: w, h: h } : null;
    }).filter(Boolean);
  }
  function aCq(items) {
    return items.map(function (i) { return i.qty + '_' + i.w + '_' + i.h; }).join('-');
  }
  // Dos veces la misma medida en el mismo papel es una sola fila con mas piezas:
  // asi el motor las acomoda juntas, igual que si se hubieran pedido de una vez.
  function fundir(items) {
    var out = [];
    items.forEach(function (i) {
      var e = out.filter(function (o) { return o.w === i.w && o.h === i.h; })[0];
      if (e) e.qty += i.qty; else out.push({ qty: i.qty, w: i.w, h: i.h });
    });
    return out;
  }

  function grupos() {
    return leer().grupos.filter(function (g) { return g && g.paper && parse(g.cq).length; });
  }
  function piezas() {
    return grupos().reduce(function (s, g) {
      return s + parse(g.cq).reduce(function (a, i) { return a + i.qty; }, 0);
    }, 0);
  }

  function agregar(paper, cq, origen) {
    var nuevas = parse(cq);
    if (!paper || !nuevas.length) return false;
    var d = leer();
    var g = d.grupos.filter(function (x) { return x.paper === paper; })[0];
    if (g) { g.cq = aCq(fundir(parse(g.cq).concat(nuevas))); if (origen) g.origen = origen; }
    else d.grupos.push({ paper: paper, cq: aCq(fundir(nuevas)), origen: origen || '' });
    guardar(d);
    medir(paper, nuevas);
    saltar();
    return true;
  }
  // Para «Editar»: lo que se guarda reemplaza al grupo de ese papel.
  function reemplazar(paper, cq, origen) {
    var d = leer();
    var items = fundir(parse(cq));
    // En su mismo lugar de la lista: editar no deberia reordenar el pedido.
    var i = -1;
    d.grupos.forEach(function (x, j) { if (x.paper === paper) i = j; });
    var nuevo = { paper: paper, cq: aCq(items), origen: origen || (i >= 0 ? d.grupos[i].origen : '') };
    if (!items.length) d.grupos = d.grupos.filter(function (x) { return x.paper !== paper; });
    else if (i >= 0) d.grupos[i] = nuevo;
    else d.grupos.push(nuevo);
    guardar(d);
    return true;
  }
  function quitarGrupo(paper) {
    var d = leer();
    d.grupos = d.grupos.filter(function (x) { return x.paper !== paper; });
    guardar(d);
  }
  function quitarPieza(paper, idx) {
    var d = leer();
    var g = d.grupos.filter(function (x) { return x.paper === paper; })[0];
    if (!g) return;
    var items = parse(g.cq);
    items.splice(idx, 1);
    if (items.length) g.cq = aCq(items);
    else d.grupos = d.grupos.filter(function (x) { return x.paper !== paper; });
    guardar(d);
  }
  // Se vacia SOLO cuando el pedido ya se pago (ver revisarPago). Antes se
  // vaciaba al ir al checkout y quien volvia sin pagar lo encontraba vacio.
  function vaciar() {
    try { localStorage.removeItem(KEY); localStorage.removeItem(KEY + '_ultimo'); } catch (e) {}
    // Y los archivos de ese pedido (los guarda el cotizador; ver lt_mp_archivos en
    // cotizador_1122). Sin esto pasaban al pedido siguiente si se vaciaba fuera del cotizador.
    try { localStorage.removeItem('lt_mp_archivos'); } catch (e) {}
    cambio();
  }

  /* ─────────────── pago iniciado (checkout de Shopify) ─────────────── */

  // Huella de las piezas: si el cliente cambia algo despues de ir al checkout,
  // ese pago ya no corresponde y el panel vuelve a «Continuar con mi pedido».
  function firma(gs) {
    return (gs || []).map(function (g) { return g.paper + ':' + g.cq; }).sort().join('|');
  }
  // La llama el cotizador al crear el pedido borrador, justo antes de llevar
  // al cliente al checkout. Guarda el link para poder retomarlo.
  function marcarPago(info) {
    if (!info || !info.url) return;
    var d = leer();
    d.pago = { url: info.url, id: info.id || null, firma: firma(d.grupos), t: Date.now() };
    guardar(d);
  }
  function pago() {
    var d = leer();
    return d.pago && d.pago.firma === firma(d.grupos) && grupos().length ? d.pago : null;
  }
  // Pregunta al Apps Script si ese pedido borrador ya se pago. Si si, se vacia.
  // Si el script aun no sabe responder (sin «pagado»), no se toca nada.
  function revisarPago() {
    var p = pago();
    if (!p || !p.id || !CFG.estado || !window.fetch) return;
    try {
      var ult = +sessionStorage.getItem('lt_mp_chk_' + p.id) || 0;
      if (Date.now() - ult < 60000) return;
      sessionStorage.setItem('lt_mp_chk_' + p.id, String(Date.now()));
    } catch (e) {}
    fetch(CFG.estado + '?draft=' + encodeURIComponent(p.id))
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.pagado === true) { var q = pago(); if (q && q.id === p.id) vaciar(); } })
      .catch(function () {});
  }

  /* ───────────────────────── motor ───────────────────────── */

  var _esperando = [];
  function motor(cb) {
    if (window.CotizadorEngine) return cb(window.CotizadorEngine);
    _esperando.push(cb);
    if (_esperando.length > 1 || !CFG.engine) return;
    var s = document.createElement('script');
    s.src = CFG.engine; s.async = true;
    s.onload = function () {
      var E = window.CotizadorEngine;
      _esperando.splice(0).forEach(function (f) { if (E) f(E); });
    };
    document.head.appendChild(s);
  }
  // Total de lo guardado, para el boton «Pagar mi pedido ($X)» de cada
  // cotizador. Sincrono: solo responde si el motor ya esta cargado, y en las
  // paginas con cotizador siempre lo esta. ok = todos los papeles sobre el minimo.
  function resumen() {
    var E = window.CotizadorEngine;
    if (!E) return null;
    var gs = grupos(), total = 0, ok = gs.length > 0;
    gs.forEach(function (g) {
      var w = precioGrupo(E, g);
      if (w) total += Math.round(w.price);
      if (!w || w.belowMin) ok = false;
    });
    return { papeles: gs.length, piezas: piezas(), total: total, ok: ok };
  }

  function precioGrupo(E, g) {
    var o = E.calculateOrder(parse(g.cq), g.paper);
    return o && o.winner ? o.winner : null;
  }

  /* ───────────────────────── medicion ───────────────────────── */

  // El sitio no usa el carrito de Shopify, asi que nadie mas avisa que alguien
  // agrego algo. Se avisa aqui a Meta, GA4 y Klaviyo, con el valor del motor.
  function medir(paper, nuevas) {
    motor(function (E) {
      var p = E.getPaper(paper) || {};
      var w = E.calculateOrder(nuevas, paper);
      var valor = w && w.winner ? Math.round(w.winner.price) : 0;
      var nombre = 'Impresión Fine Art · ' + (p.tab || paper);
      var n = nuevas.reduce(function (a, i) { return a + i.qty; }, 0);
      try { if (window.fbq) window.fbq('track', 'AddToCart', { value: valor, currency: 'CLP', content_name: nombre, content_type: 'product', num_items: n }); } catch (e) {}
      try { if (window.gtag) window.gtag('event', 'add_to_cart', { currency: 'CLP', value: valor, items: [{ item_name: nombre, item_variant: p.tab || paper, quantity: n, price: valor }] }); } catch (e) {}
      try {
        var k = window.klaviyo || window._learnq;
        if (k && k.push) k.push(['track', 'Agregó a Mi pedido', {
          Papel: p.tab || paper, Piezas: n, Valor: valor, URL: location.href,
          Medidas: nuevas.map(function (i) { return i.qty + '× ' + i.w + '×' + i.h; }).join(', ')
        }]);
      } catch (e) {}
    });
  }

  /* ───────────────────────── panel ───────────────────────── */

  var CSS = [
    // display:block con !important: el tema oculta todo div vacio (div:empty), y
    // sin el velo no se oscurecia la pagina ni se podia cerrar haciendo clic afuera.
    '.mp-velo{display:block!important;position:fixed;inset:0;background:rgba(20,18,16,.45);opacity:0;pointer-events:none;transition:opacity .2s;z-index:2147483000;cursor:pointer}',
    '.mp-velo.abierto{opacity:1;pointer-events:auto}',
    '.mp-panel{position:fixed;top:0;right:0;bottom:0;width:min(440px,100vw);background:#fff;color:#1d1b18;z-index:2147483001;',
    'transform:translateX(100%);transition:transform .25s ease;display:flex;flex-direction:column;font-family:inherit;box-shadow:-12px 0 40px rgba(0,0,0,.18)}',
    '.mp-panel.abierto{transform:none}',
    '.mp-cab{display:flex;align-items:center;justify-content:space-between;padding:18px 20px;border-bottom:1px solid #ece6dc}',
    '.mp-cab h2{margin:0;font-size:20px;font-weight:800;letter-spacing:0}',
    '.mp-cab small{display:block;font-size:13px;font-weight:600;color:#6b645a;margin-top:2px}',
    '.mp-x{background:none;border:0;font-size:26px;line-height:1;cursor:pointer;color:#1d1b18;padding:4px 8px}',
    '.mp-ok{margin:14px 20px 0;padding:10px 14px;border-radius:10px;background:#eef7f0;color:#25633a;font-size:14px;font-weight:700}',
    '.mp-cuerpo{flex:1;overflow-y:auto;padding:6px 20px 20px}',
    '.mp-vacio{padding:40px 6px;text-align:center;color:#6b645a;font-size:15px}',
    '.mp-vacio a{display:inline-block;margin:14px 6px 0;padding:11px 20px;border-radius:999px;background:#D6232A;color:#fff;font-weight:800;text-decoration:none}',
    '.mp-vacio a.sec{background:none;color:#1d1b18;border:1.5px solid #d6cfc4}',
    '.mp-g{padding:16px 0;border-bottom:1px solid #ece6dc}',
    '.mp-gt{display:flex;justify-content:space-between;gap:10px;align-items:baseline}',
    '.mp-gt b{font-size:16px;font-weight:800}',
    '.mp-gt b i{display:inline-block;width:10px;height:10px;border-radius:50%;margin-right:8px;vertical-align:1px}',
    '.mp-gt span{font-size:16px;font-weight:800;font-variant-numeric:tabular-nums;white-space:nowrap}',
    '.mp-fin{font-size:12.5px;color:#6b645a;margin:2px 0 8px 18px}',
    '.mp-l{display:flex;justify-content:space-between;align-items:center;gap:8px;font-size:14.5px;padding:3px 0 3px 18px}',
    '.mp-l button{background:none;border:0;color:#8a8378;font-size:18px;cursor:pointer;padding:0 4px;line-height:1}',
    '.mp-l button:hover{color:#D6232A}',
    '.mp-acc{display:flex;gap:16px;margin:8px 0 0 18px;font-size:13px}',
    '.mp-acc a,.mp-acc button{background:none;border:0;padding:0;color:#1d1b18;text-decoration:underline;cursor:pointer;font:inherit;font-size:13px}',
    '.mp-aviso{margin:8px 0 0 18px;font-size:13px;color:#a31d22;font-weight:700}',
    '.mp-pie{border-top:1px solid #ece6dc;padding:16px 20px 20px;background:#faf8f4}',
    '.mp-tot{display:flex;justify-content:space-between;align-items:baseline;gap:10px}',
    '.mp-tot span{font-size:14px;color:#6b645a;font-weight:700}',
    '.mp-tot b{font-size:24px;font-weight:900;font-variant-numeric:tabular-nums}',
    '.mp-envio{font-size:12.5px;color:#6b645a;margin:4px 0 14px}',
    '.mp-pagar{display:block;width:100%;text-align:center;padding:15px;border-radius:999px;background:#D6232A;color:#fff;font-weight:800;font-size:16px;text-decoration:none;border:0;cursor:pointer}',
    '.mp-pagar[aria-disabled=true]{background:#cfc8bd;pointer-events:none}',
    '.mp-todos{display:block;text-align:center;margin-top:12px;font-size:13px;color:#6b645a;text-decoration:underline}',
    '.mp-sugs{padding:18px 0 4px}',
    '.mp-sugt{margin:0 0 10px;font-size:12.5px;font-weight:800;letter-spacing:.07em;text-transform:uppercase;color:#6b645a}',
    '.mp-sugl{display:flex;flex-direction:column;gap:0}',
    '.mp-ayuda{margin:16px 0 0;font-size:13px;line-height:1.5;color:#6b645a}',
    '.mp-btn2{margin-top:16px;padding:12px;border:1.5px solid #d6cfc4;border-radius:999px;font-weight:800;color:#1d1b18;text-decoration:none;font-size:14px}',
    '.mp-top{background:#D6232A;color:#fff}',
    '.mp-sug{display:flex;align-items:center;gap:12px;padding:8px 4px;border:0;border-bottom:1px solid #ece6dc;border-radius:0;background:none;color:#1d1b18;text-decoration:none;transition:background .15s}',
    '.mp-sug:hover{background:#faf8f4}',
    '.mp-sug img,.mp-sug .mp-sugimg{width:42px;height:42px;border-radius:8px;object-fit:cover;flex:none;background:#f1ece4}',
    '.mp-sugn{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}',
    '.mp-sugn b{font-size:15px;font-weight:800}',
    '.mp-sugn small{font-size:12.5px;color:#6b645a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.mp-sug>i{font-style:normal;color:#8a8378;font-size:18px}',
    '.mp-sug.aqui{border-style:dashed}',
    '.mp-museo{font-style:normal;font-size:10.5px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#8a6d2b;background:#f6eedb;border-radius:999px;padding:2px 7px;margin-left:6px;vertical-align:2px}',
    '[data-mp-cuenta][hidden]{display:none!important}',
    '[data-mp-aviso]{margin:10px 0 0;font-size:13px;line-height:1.45;color:#6b645a}',
    '[data-mp-aviso][hidden]{display:none!important}',
    '[data-mp-aviso] a{color:inherit;font-weight:800;text-decoration:underline;white-space:nowrap}',
    '.mp-toast{position:fixed;left:50%;bottom:96px;transform:translate(-50%,20px);opacity:0;transition:opacity .2s,transform .2s;z-index:2147483002;',
    'background:#1d1b18;color:#fff;border-radius:999px;padding:11px 18px;font-size:14px;font-weight:700;box-shadow:0 8px 24px rgba(0,0,0,.25);max-width:calc(100vw - 32px)}',
    '.mp-toast.ver{opacity:1;transform:translate(-50%,0)}',
    '.mp-toast a{color:#fff;margin-left:10px;text-decoration:underline}',
    '@media (prefers-reduced-motion:reduce){.mp-panel,.mp-velo{transition:none}}'
  ].join('');

  var panel, velo, _okMsg = '';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function fmt(n) { return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function num(n) { return String(n).replace('.', ','); }

  var _cssPuesto = false;
  function ponerCss() {
    if (_cssPuesto) return; _cssPuesto = true;
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
  }

  function montar() {
    if (panel) return;
    ponerCss();
    velo = document.createElement('div'); velo.className = 'mp-velo';
    panel = document.createElement('aside');
    panel.className = 'mp-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Mi pedido');
    panel.setAttribute('tabindex', '-1');
    document.body.appendChild(velo); document.body.appendChild(panel);
    velo.addEventListener('click', cerrar);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('abierto')) cerrar(); });
    panel.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mp]'); if (!t) return;
      var a = t.dataset.mp;
      if (a === 'cerrar') { e.preventDefault(); cerrar(); }
      // Al quitar, el «✓ Agregaste…» de arriba ya no corresponde.
      else if (a === 'quitar-g') { _okMsg = ''; desdeFuera('panel', function () { quitarGrupo(t.dataset.p); }); }
      else if (a === 'quitar-l') { _okMsg = ''; desdeFuera('panel', function () { quitarPieza(t.dataset.p, +t.dataset.i); }); }
    });
  }

  // «Suma otro papel»: los papeles de MP_CFG.lista que aun no estan en el
  // pedido, con su foto. El de la pagina actual se marca «Estás aquí» y solo
  // cierra el panel (llevar a la misma pagina seria recargarla).
  function sugerencias(E, gs, titulo) {
    var en = {};
    gs.forEach(function (g) { en[g.paper] = 1; });
    var aquiUrl = location.pathname.replace(/\/$/, '');
    var lista = (CFG.lista || []).filter(function (x) { return x && !en[x.id] && E.getPaper(x.id); });
    var ORDEN = ['fs-smooth', 'c-etching', 'fs-watercolor', 'hn-luster', 'fs-satin'];
    lista.sort(function (a, b) { var i = ORDEN.indexOf(a.id), j = ORDEN.indexOf(b.id); return (i < 0 ? 99 : i) - (j < 0 ? 99 : j); });
    if (!lista.length) return '';
    return '<div class="mp-sugs"><p class="mp-sugt">' + esc(titulo) + '</p><div class="mp-sugl">' +
      lista.map(function (x) {
        var p = E.getPaper(x.id), aqui = x.url === aquiUrl;
        var sub = aqui ? 'Estás aquí' : String(p.finish || '').replace(/ satinado/i, '').replace(/^mate grano fino \(algod\u00f3n\)$/i, 'mate \u00b7 algod\u00f3n').replace(/^texturado mate \(algod\u00f3n\)$/i, 'texturado \u00b7 algod\u00f3n');
        var museo = p.line === 'museo' ? ' <em class="mp-museo">Museo</em>' : (!gs.length && x.id === 'fs-smooth' ? ' <em class="mp-museo mp-top">El más elegido</em>' : '');
        return '<a class="mp-sug' + (aqui ? ' aqui' : '') + '" href="' + esc(x.url) + '"' + (aqui ? ' data-mp="cerrar"' : '') + '>' +
          (x.img ? '<img src="' + esc(x.img) + '" alt="" loading="lazy">' : '<span class="mp-sugimg"></span>') +
          '<span class="mp-sugn"><b>' + esc(p.tab) + museo + '</b><small>' + esc(sub) + '</small></span><i aria-hidden="true">→</i></a>';
      }).join('') + '</div></div>';
  }

  function pintar() {
    if (!panel) return;
    var gs = grupos(), n = piezas();
    var cab = '<div class="mp-cab"><div><h2>Mi pedido</h2><small>' +
      (n ? n + (n === 1 ? ' impresión' : ' impresiones') + ' · ' + gs.length + (gs.length === 1 ? ' papel' : ' papeles') : 'Tu pedido está vacío') +
      '</small></div><button type="button" class="mp-x" data-mp="cerrar" aria-label="Cerrar">×</button></div>' +
      (_okMsg ? '<div class="mp-ok" role="status">✓ ' + esc(_okMsg) + '</div>' : '');

    if (!gs.length) {
      var vacio = '';
      panel.innerHTML = cab + '<div class="mp-cuerpo">' + vacio + '</div>';
      motor(function (E) {
        panel.innerHTML = cab + '<div class="mp-cuerpo">' + sugerencias(E, gs, 'Elige un papel para empezar') +
          '<p class="mp-ayuda">¿No sabes cuál? Smooth es el más pedido. Si buscas textura de algodón, mira Etching o Watercolor.</p>' +
          '<a class="mp-todos mp-btn2" href="' + esc(CFG.cotizar || '/products/cotizador') + '">Cotizar con todos los papeles</a></div>';
      });
      return;
    }

    panel.innerHTML = cab + '<div class="mp-cuerpo"><p class="mp-vacio" style="padding:30px 0">Calculando…</p></div>';
    motor(function (E) {
      var total = 0, todoOk = true, cuerpo = '';
      gs.forEach(function (g, gi) {
        var p = E.getPaper(g.paper) || {};
        var w = precioGrupo(E, g);
        var items = parse(g.cq);
        if (w) total += Math.round(w.price);
        var bajo = !w || w.belowMin;
        if (bajo) todoOk = false;
        var editar = (CFG.cotizar || '/products/cotizador') + '?cq_p=' + encodeURIComponent(g.paper) +
          '&cq_i=' + encodeURIComponent(g.cq) + '&mp_edit=1';
        cuerpo += '<div class="mp-g"><div class="mp-gt"><b><i style="background:' + COLORES[gi % COLORES.length] + '"></i>' +
          esc(p.tab || g.paper) + '</b><span>' + (w ? fmt(w.price) : '—') + '</span></div>' +
          '<div class="mp-fin">' + esc([p.finish, p.weight ? p.weight.replace('grs', ' g') : ''].filter(Boolean).join(' · ')) +
          (w ? ' · rollo ' + w.rollW + '×' + Math.ceil(w.realLength) + ' cm' : '') + '</div>' +
          items.map(function (i, ii) {
            return '<div class="mp-l"><span>' + i.qty + '× ' + num(i.w) + '×' + num(i.h) + ' cm</span>' +
              '<button type="button" data-mp="quitar-l" data-p="' + esc(g.paper) + '" data-i="' + ii + '" aria-label="Quitar ' + i.qty + '× ' + num(i.w) + '×' + num(i.h) + ' cm">×</button></div>';
          }).join('') +
          (bajo ? '<p class="mp-aviso">' + (w ? 'Bajo el mínimo de impresión de este papel (' + w.rollW + '×' + w.minRollLen + ' cm): agrega más piezas.' : 'No pudimos calcular este papel. Escríbenos y lo cotizamos.') + '</p>' : '') +
          '<div class="mp-acc"><a href="' + esc(editar) + '">Editar</a>' +
          '<button type="button" data-mp="quitar-g" data-p="' + esc(g.paper) + '">Quitar ' + esc(p.tab || 'papel') + '</button></div></div>';
      });

      var pagar = (CFG.cotizar || '/products/cotizador') + '?mp=1&cq_s=2&cq_ret=' + encodeURIComponent(location.pathname);
      // Ya fue al checkout y no cambio nada: lo natural es retomar ESE pago
      // (con sus archivos ya subidos) y no crear otro pedido.
      var pend = pago();
      var accion = pend
        ? '<p class="mp-envio">Tu pedido está guardado. Puedes retomar el pago donde lo dejaste.</p>' +
          '<a class="mp-pagar" href="' + esc(pend.url) + '">Retomar pago</a>' +
          '<a class="mp-todos" href="' + esc(pagar) + '">Cambiar archivos o envío</a>'
        : '<p class="mp-envio">Tus archivos los subes en el siguiente paso. Despacho por pagar al recibir, desde aprox. $3.500 en RM (o retiro coordinado).</p>' +
          '<a class="mp-pagar" href="' + esc(pagar) + '"' + (todoOk ? '' : ' aria-disabled="true"') + '>Continuar con mi pedido</a>';
      panel.innerHTML = cab + '<div class="mp-cuerpo">' + cuerpo + sugerencias(E, gs, 'Suma otro papel') + '</div>' +
        '<div class="mp-pie"><div class="mp-tot"><span>Total' + (gs.length > 1 ? ' · ' + gs.length + ' papeles, un solo envío' : '') + '</span><b>' + fmt(total) + '</b></div>' +
        accion + '</div>';
    });
  }

  function abrir(msg) {
    montar();
    _okMsg = msg || '';
    pintar();
    velo.classList.add('abierto'); panel.classList.add('abierto');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { try { panel.focus(); } catch (e) {} }, 50);
  }
  function cerrar() {
    if (!panel) return;
    velo.classList.remove('abierto'); panel.classList.remove('abierto');
    document.documentElement.style.overflow = '';
    _okMsg = '';
  }

  /* ───────────────────────── icono y avisos ───────────────────────── */

  function pintarIcono() {
    var n = piezas();
    document.querySelectorAll('[data-mp-cuenta]').forEach(function (b) {
      b.hidden = !n;
      var s = b.querySelector('span'); if (s) s.textContent = n > 99 ? '99+' : String(n);
    });
  }
  /* ───────────────────────── aviso junto a «Continuar» ───────────────────────── */

  // Cada cotizador tiene un [data-mp-aviso] junto a su boton Continuar. Si hay
  // papeles guardados, avisa que se pagan juntos: si no, el cliente se
  // sorprenderia al ver en el pago papeles que no esta mirando.
  // En el pago mismo (?mp=1) no hace falta: ahi el resumen ya los muestra.
  function pintarAvisos() {
    var els = document.querySelectorAll('[data-mp-aviso]');
    if (!els.length) return;
    var gs0 = grupos();
    if (!gs0.length || /[?&]mp=1(&|$)/.test(location.search)) {
      els.forEach(function (e) { e.hidden = true; e.innerHTML = ''; });
      return;
    }
    // 23-oct-2026: solo cuentan los OTROS papeles. Fuera la cotización activa de esta página (espejo,
    // ver cotizador_1122) y lo que el cotizador marque en data-mp-excluir (el papel que se está editando).
    var esp = null; try { esp = JSON.parse(sessionStorage.getItem('lt_mp_espejo') || 'null'); } catch (x) {}
    motor(function (E) {
      document.querySelectorAll('[data-mp-aviso]').forEach(function (e) {
        var excl = (e.getAttribute('data-mp-excluir') || '').split(',').filter(Boolean);
        if (esp && esp.p && esp.path === location.pathname) excl.push(esp.p);
        var gs = gs0.filter(function (g) { return excl.indexOf(g.paper) < 0; });
        if (!gs.length) { e.hidden = true; e.innerHTML = ''; return; }
        var total = gs.reduce(function (s, g) { var w = precioGrupo(E, g); return s + (w ? Math.round(w.price) : 0); }, 0);
        var ver = ' <a href="#" data-mp-abrir>Ver pedido</a>';
        var actual = +(e.getAttribute('data-mp-actual') || 0);
        // data-mp-vacio: el cotizador de al lado no tiene nada armado.
        if (e.hasAttribute('data-mp-vacio')) e.innerHTML = 'Tienes ' + (gs.length === 1 ? '1 papel' : gs.length + ' papeles') + ' en tu pedido.' + ver;
        else if (actual > 0) e.innerHTML = 'Otras impresiones del pedido: <b>' + fmt(total) + '</b> · Total de impresiones: <b>' + fmt(total + actual) + '</b>.' + ver;
        else e.innerHTML = 'Otras impresiones del pedido: <b>' + fmt(total) + '</b>, se pagan junto con lo que armes aquí.' + ver;
        e.hidden = false;
      });
    });
  }

  /* ───────────────────────── confirmacion breve ───────────────────────── */

  var _toast, _toastT;
  function toast(msg) {
    ponerCss();
    if (!_toast) { _toast = document.createElement('div'); _toast.className = 'mp-toast'; _toast.setAttribute('role', 'status'); document.body.appendChild(_toast); }
    _toast.innerHTML = '✓ ' + esc(msg) + '<a href="#" data-mp-abrir>Ver pedido</a>';
    _toast.classList.add('ver');
    clearTimeout(_toastT);
    _toastT = setTimeout(function () { _toast.classList.remove('ver'); }, 4000);
  }

  // El numero del icono da un salto al agregar: confirma DONDE quedo lo agregado.
  function saltar() {
    document.querySelectorAll('[data-mp-cuenta]').forEach(function (b) {
      b.classList.remove('mp-salta'); void b.offsetWidth; b.classList.add('mp-salta');
    });
  }

  // detail.externo dice si el cambio vino del panel o de otra pestaña. Los cotizadores lo usan
  // para quitar de su pantalla lo que se quito en el panel (antes el panel quedaba vacio y el
  // resumen del paso 2 seguia con el pedido y el boton de pagar). Lo que escribe un cotizador
  // llega sin externo: eso ya esta en su pantalla.
  var _externo = '';
  function desdeFuera(origen, fn) {
    _externo = origen;
    try { fn(); } finally { _externo = ''; }
  }
  function cambio() {
    pintarIcono();
    pintarAvisos();
    if (panel && panel.classList.contains('abierto')) pintar();
    try { document.dispatchEvent(new CustomEvent('mipedido:cambio', { detail: { piezas: piezas(), externo: _externo } })); } catch (e) {}
  }
  // Otra pestaña cambio el pedido: se refleja aqui sin recargar.
  window.addEventListener('storage', function (e) { if (e.key === KEY) desdeFuera('pestaña', cambio); });

  // En fase de captura y cortando la propagacion: el tema tiene sus propios
  // escuchas sobre el icono del carrito que abririan su panel (vacio).
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-mp-abrir]');
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    abrir();
  }, true);

  // Otro script del tema esconde la burbuja del carrito en linea cuando el
  // carrito de Shopify esta vacio (y aqui siempre lo esta). Esta regla con
  // !important le gana al estilo en linea; el atributo hidden decide.
  function listo() {
    var st = document.createElement('style');
    st.textContent = '[data-mp-cuenta]:not([hidden]){display:flex!important}[data-mp-cuenta][hidden]{display:none!important}';
    document.head.appendChild(st);
    ponerCss();
    pintarIcono();
    pintarAvisos();
    revisarPago();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', listo); else listo();

  // Link del correo de «pedido pendiente»: ?mp_restore=papel:cq;papel:cq deja el
  // pedido en Mi pedido de este navegador (el link con ?mp=1 lo paga entero).
  (function () {
    try {
      var u = new URL(location.href), r = u.searchParams.get('mp_restore');
      if (!r) return;
      var gs = r.split(';').map(function (t) { var i = t.indexOf(':'); return { paper: t.slice(0, i), cq: t.slice(i + 1) }; })
        .filter(function (g) { return g.paper && parse(g.cq).length; })
        .map(function (g) { return { paper: g.paper, cq: g.cq, origen: 'Correo' }; });
      if (gs.length) { try { localStorage.setItem(KEY, JSON.stringify({ grupos: gs, t: Date.now() })); } catch (e) {} }
      u.searchParams.delete('mp_restore');
      history.replaceState(null, '', u.toString());
    } catch (e) {}
  })();

  window.MiPedido = {
    grupos: grupos, piezas: piezas, parse: parse,
    agregar: agregar, reemplazar: reemplazar, quitarGrupo: quitarGrupo, vaciar: vaciar, marcarPago: marcarPago, pago: pago,
    abrir: abrir, cerrar: cerrar, toast: toast, pintarAvisos: pintarAvisos, resumen: resumen
  };
})();
